// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-dialog {\n  max-width: 650px;\n}\n.modal-dialog .modal-footer .mat-icon {\n  width: 15px;\n  height: 15px;\n  font-size: 15px;\n  margin-right: 5px;\n}\n.modal-dialog .modal-footer button {\n  display: flex;\n  align-items: center;\n}\n.modal-dialog mat-stepper::ng-deep .mat-horizontal-content-container {\n  padding: 0;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
